export const useDateTimeFormatter = () => {
  const formatLastSeenDateTime = (dateString) => {
    if (!dateString) return "-";

    try {
      const date = new Date(
        dateString.endsWith("Z") ? dateString : dateString + "Z"
      );
      const now = new Date();
      const diffMs = now - date;
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffMinutes = Math.floor(diffMs / (1000 * 60));

      if (diffMinutes < 1) return "Just now";
      else if (diffHours < 1) return `${diffMinutes}m ago`;
      else if (diffDays === 0)
        return date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
      else if (diffDays === 1) return "Yesterday";
      else if (diffDays < 7) return `${diffDays}d ago`;
      else return date.toLocaleDateString();
    } catch (error) {
      console.error("Date formatting error:", error);
      return "Invalid";
    }
  };

  const formatLastLoginDateTime = (dateString) => {
    if (!dateString) return "-";

    try {
      const date = new Date(
        dateString.endsWith("Z") ? dateString : dateString + "Z"
      );
      const now = new Date();
      const diffMs = now - date;
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      if (diffDays === 0) return "Today";
      else if (diffDays === 1) return "1 day ago";
      else if (diffDays < 30) return `${diffDays} days ago`;
      else if (diffDays < 365) {
        const months = Math.floor(diffDays / 30);
        return months === 1 ? "1 month ago" : `${months} months ago`;
      } else {
        const years = Math.floor(diffDays / 365);
        return years === 1 ? "1 year ago" : `${years} years ago`;
      }
    } catch (error) {
      console.error("Date formatting error:", error);
      return "Invalid";
    }
  };

  const formatDetailedDateTime = (dateString) => {
    if (!dateString) return "Never";

    try {
      const date = new Date(
        dateString.endsWith("Z") ? dateString : dateString + "Z"
      );
      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        timeZoneName: "short",
      });
    } catch (error) {
      console.error("Date formatting error:", error);
      return "Invalid date";
    }
  };

  return {
    formatLastSeenDateTime,
    formatLastLoginDateTime,
    formatDetailedDateTime,
  };
};
